let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dAZkz")).then(() => parcelRequire('bjI3S'));